module.exports = __webpack_public_path__ + "img/pulled_pork_pulled.010aab3c.jpg";